import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserManagementService {
  private _userInfos: BehaviorSubject<any> = new BehaviorSubject(null);
  private _roleDetails: BehaviorSubject<any> = new BehaviorSubject(null);
  private _permissions: BehaviorSubject<any> = new BehaviorSubject(null);
  private _roles: BehaviorSubject<any> = new BehaviorSubject(null);
  private _createdRole: BehaviorSubject<any> = new BehaviorSubject(null);


  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for data
   */
  get userInfo$(): Observable<any> {
    return this._userInfos.asObservable();
  }

  get roleDetails$(): Observable<any> {
    return this._roleDetails.asObservable();
  }

  get roles$(): Observable<any> {
    return this._roles.asObservable();
  }

  get createdRole$(): Observable<any> {
    return this._createdRole.asObservable();
  }

  get permissions$(): Observable<any> {
    return this._permissions.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   *  USER'S INFO 
   */

  getUserInfo(pageNumber: any, pageSize: any): Observable<any> {

    let Params = new HttpParams()
    Params = Params.append('page', pageNumber);
    Params = Params.append('pageSize', pageSize);

    return this._httpClient.get<any>(`${environment.apiURL}/${environment.apiVersion}/Account/GetUsersInfo`, { params: Params }).pipe(
      tap((response: any) => {
        this._userInfos.next(response);
      }),
    );
  }

  updateUsersInfo(userInfoBody: any): Observable<any> {
    return this._httpClient.put<any>(`${environment.apiURL}/${environment.apiVersion}/Account/UpdateUserInfo`, userInfoBody).pipe(
      tap((response: any) => {
        this._createdRole.next(response);
      }),
    );
  }

  // 
  // USERS' ROLES
  // 

  getRoles(pageNumber: any, pageSize: any): Observable<any> {

    let Params = new HttpParams()
    Params = Params.append('page', pageNumber);
    Params = Params.append('pageSize', pageSize);

    return this._httpClient.get<any>(`${environment.apiURL}/${environment.apiVersion}/Roles/GetRoles`, { params: Params }).pipe(
      tap((response: any) => {
        this._roles.next(response.data.data);
      }),
    );
  }

  createRoles(roleBody: any): Observable<any> {
    return this._httpClient.post<any>(`${environment.apiURL}/${environment.apiVersion}/Roles/CreateRole`, roleBody).pipe(
      tap((response: any) => {
        this._createdRole.next(response);
      }),
    );
  }

  getRoleDetails(pageNumber: any, pageSize: any): Observable<any> {

    let Params = new HttpParams()
    Params = Params.append('page', pageNumber);
    Params = Params.append('pageSize', pageSize);

    return this._httpClient.get<any>(`${environment.apiURL}/${environment.apiVersion}/Account/GetRoleDetails`, { params: Params }).pipe(
      tap((response: any) => {
        this._roleDetails.next(response);
      }),
    );
  }

  // 
  // USERS' PERMISSIONS
  // 


  getPermissions(): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiURL}/${environment.apiVersion}/Permission/GetPermissions`).pipe(
      tap((response: any) => {
        this._permissions.next(response);
        return response
      }),
    );
  }

  assignOrUpdatePermissionToRole(rolePermissionBody) {
    return this._httpClient.post<any>(`${environment.apiURL}/${environment.apiVersion}/Roles/AssignOrUpdatePermissionToRole`, rolePermissionBody).pipe(
      tap((response: any) => {
        this._createdRole.next(response);
        return response
      }),
    );
  }
}
